import * as React from 'react'
// hooks
import { useShowModal } from 'hooks'
// components
import Row from './components/Row'
import { Button, BUTTON_LAYOUTS, Table } from 'components/UI'
// context
import { GroupSecurityContext } from 'containers/Security/components/GroupSecurity/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// constants
import { Modals } from 'constants/index'
// view components
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import GroupSecurityCreateModal from 'components/Modals/GroupSecurityModal'
// views
import { Title, TitleWrapper } from 'themes/views/security'

const headers = [
  { id: 'name', sortable: false, left: true, label: 'NAME' },
  { id: 'createdAt', sortable: false, left: true, label: 'DATE CREATE' },
  { id: 'active', sortable: false, left: true, label: 'ACTIVE' }
]

const GroupSecurity: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(GroupSecurityContext)

  const { showModal } = useShowModal({ modalType: Modals.GROUP_SECURITY_MODAL })

  return (
    <>
      <TitleWrapper>
        <Title>
          Group security allow profiles to be associated with groups of people with the ability to define business rules
          governing access to what data can be accessed
        </Title>
        <Button onClick={() => showModal()} type='button' layout={BUTTON_LAYOUTS.PURPLE}>
          CREATE NEW
        </Button>
      </TitleWrapper>
      <Table
        data={data}
        page={page}
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) => data.map((item) => <Row key={item.id} data={item} />)}
      </Table>

      <GroupSecurityCreateModal />
      <ConfirmDeleteModal header='Delete Group Security'>
        Are you sure you want to delete this group security?
      </ConfirmDeleteModal>
    </>
  )
}

export default GroupSecurity
